import "./ProviderAvailabilityPage.css";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ProviderAvailabilityTab from "./ProviderAvailabilityTab";
import "./ProviderDetails.css";

const ProviderAvailabilityPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const user = useSelector((state) => state?.user?.user);

  useEffect(() => {
    if (
      user?.role === "provider" ||
      user?.role === "careManager" ||
      user?.providerType === "Care Manager"
    ) {
      setIsLoading(false);
    } else if (user) {
      toast.error("Access denied. Authorized access only.");
      window.history.back();
    }
  }, [user]);

  if (isLoading) {
    return (
      <div className="app-page">
        <div className="bg-white rounded shadow-sm availability-page-loading">
          <div className="loading-spinner"></div>
          <p>Loading availability page...</p>
        </div>
      </div>
    );
  }

  const isAuthorized =
    user?.role === "provider" ||
    user?.role === "careManager" ||
    user?.providerType === "Care Manager";

  if (!user || !isAuthorized) {
    return (
      <div className="app-page">
        <div className="bg-white rounded shadow-sm access-denied">
          <h2>Access Denied</h2>
          <p>
            This page is only accessible to healthcare providers and care
            managers.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="app-page provider-availability-page">
      <div className="provider-availability-page-inner">
        <h1 className="provider-availability-page-title">My Availability</h1>
        <ProviderAvailabilityTab
          getProviderId={() => user.providerId}
          canManage
        />
      </div>
    </div>
  );
};

export default ProviderAvailabilityPage;
